"use strict";
/**
 * @module Services.SessionTrees
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The response of the GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS service
 */
var SessionTreeBranchList = /** @class */ (function () {
    /**
     * Create a new SessionTreeBranchList instance
     *
     * @param paths  the source branches
     */
    function SessionTreeBranchList(paths) {
        this.paths = paths;
    }
    return SessionTreeBranchList;
}());
exports.SessionTreeBranchList = SessionTreeBranchList;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-trees/session-tree-branch-list.js
// module id = 1353
// module chunks = 1